import { CommonService } from '@/app/shared/services/common.service';
import { FileService } from '@/app/shared/services/file.service';
import { Component, EventEmitter, Input, Output, TemplateRef, ViewChild } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import moment from 'moment';
import { Select2 } from 'ng-select2-component';
import { ToastrService } from 'ngx-toastr';

@Component({
  selector: 'app-pharmaceutical-standard',
  templateUrl: './pharmaceutical-standard.component.html',
  styleUrl: './pharmaceutical-standard.component.scss'
})
export class PharmaceuticalStandardComponent {

  @ViewChild('loadingModal', { static: false }) loadingModal: TemplateRef<string>;
  @ViewChild('confirmModal', { static: false }) confirmModal: TemplateRef<string>;

  @Input() businessScopes: any[] = [];
  @Input() user: any;
  @Input() files: any[] = [];
  @Input() fileType: any;

  @Output() confirmForm: EventEmitter<any> = new EventEmitter();
  @Output() closeForm: EventEmitter<any> = new EventEmitter();

  form: FormGroup;
  scopes: any[] = [];

  constructor(
    private modalService: NgbModal,
    private formBuilder: FormBuilder,
    private fileService: FileService,
    private commonService: CommonService,
    private toastService: ToastrService
  ) {
    this.form = this.formBuilder.group({
      distributionCertificationsNo: new FormControl('', [Validators.required]),
      distributionCertificationsDate: new FormControl('', [Validators.required]),
      distributionCertificationsExpirationDate: new FormControl('', [Validators.required]),
      distributionCertificationsProvince: new FormControl('', [Validators.required]),
    });
  }

  ngOnInit() {
    this.scopes = this.businessScopes;
  }

  open() {
    this.form.reset();
    let loadingModal = this.modalService.open(this.loadingModal, {
      backdrop: 'static',
      ariaLabelledBy: 'address-add-Modal',
      centered: true,
      size: 'xl',
      windowClass: 'theme-modal modal-login',
    });
    loadingModal.shown.subscribe(() => {
      this.readFiles(this.files);
    });
  }

  openModal() {
    this.modalService.open(this.confirmModal, {
      backdrop: 'static',
      ariaLabelledBy: 'address-add-Modal',
      centered: true,
      size: 'xl',
      windowClass: 'theme-modal modal-login',
    }).result.then(
      (result) => {
        `Result ${result}`;
      },
      (reason) => {}
    );
  }

  readFiles(files: any) {
    this.fileService.uploadTextract(files, this.fileType, this.user.userName).subscribe({
      next: (res: any) => {
        if (res) {
          if (res.ocrResult.confidence_score < 0.9) {
            this.toastService.error('Hình ảnh không rõ nét, vui lòng chọn ảnh khác!', '', { positionClass: 'toast-top-right' });
            // this.onClose();
            return;
          }
          
          let certificationDate = this.commonService.convertDateToNgbDate(moment(this.commonService.convertVietnameseDateToNumeric(res.ocrResult.certificate_valid_from)).format('YYYY-MM-DD') || '');
          let expirationDate = this.commonService.convertDateToNgbDate(moment(this.commonService.convertVietnameseDateToNumeric(res.ocrResult.certificate_valid_from)).add(Number(res.ocrResult.certificate_valid_duration), 'y').format('YYYY-MM-DD') || '');
          let scopes = Object.values(res.ocrResult.check_box);
          for (let i = 0; i < scopes.length; i++) {
            this.scopes[i].checked = scopes[i] == 1;
          };
          
          this.form.patchValue({
            distributionCertificationsNo: res.ocrResult.id_number,
            distributionCertificationsDate: certificationDate,
            distributionCertificationsExpirationDate: expirationDate,
            distributionCertificationsProvince: res.ocrResult.issuing_authority,
          });
        }
      },
      error: (err) => {
        console.log(err);
        this.toastService.error('Có lỗi xảy ra, vui lòng thử lại!', '', { positionClass: 'toast-top-right' });
        this.onClose();
      },
      complete: () => {
        this.modalService.dismissAll();
        this.openModal();
      }
    });
  }

  onConfirm() {
    this.confirmForm.emit({form: this.form.value, scopes: this.scopes});
    this.modalService.dismissAll();
  }

  onClose() {
    this.modalService.dismissAll();
    this.closeForm.emit();
  }

}
